module.exports = __webpack_public_path__ + "img/img_beyond.e0503a29.svg";